import React, { FC } from "react";

import { v4 } from "uuid";

import { useCarousel } from "hooks/useCarousel";

type TCardType = "voebiz" | "essencial" | "prime" | "super" | "exclusive";

export type TCards = { type: TCardType; current?: boolean; title: string; desc1: string; desc2: string };

const cardsMock: TCards[] = [
  {
    type: "voebiz",
    title: "Categoria VoeBiz",
    desc1: "Basta se cadastrar no VoeBiz e já começar a juntar pontos.",
    desc2: "Receba de volta 3% do valor da passagem em pontos VoeBiz.",
  },
  {
    type: "essencial",
    title: "Categoria Essencial",
    desc1: "100 mil a 350 mil em passagens com a GOL.",
    desc2: "Receba de volta 5% do valor da passagem em pontos VoeBiz.",
  },
  {
    type: "prime",
    title: "Categoria Prime",
    desc1: "350 mil a 1 milhão em passagens com a GOL.",
    desc2: "Receba de volta 8% do valor da passagem em pontos VoeBiz.",
  },
  {
    type: "super",
    title: "Categoria Super Prime",
    desc1: "1 milhão a 2 milhões em passagens com a GOL.",
    desc2: "Receba de volta 10% do valor da passagem em pontos VoeBiz.",
  },
  {
    type: "exclusive",
    title: "Categoria Exclusive",
    desc1: "Negociação comercial exclusiva.",
    desc2: "",
  },
];

const InstBenefitsCategorias: FC = () => {
  const cards = cardsMock;

  const { prev, next, containerRef, checkScrollLimit, carouselState } = useCarousel({
    cards,
    className: "liferay-category-more-benefits__carousel__inst-card",
  });

  return (
    <section
      className="liferay-category-more-benefits inst-background"
      data-testid="inst-benefits"
      id="subir-categoria"
    >
      <div className="liferay-category-more-benefits__container">
        <div className="liferay-category-more-benefits__main-header">
          <h2 className="liferay-category-more-benefits__title">Sua empresa pode subir de categoria no VoeBiz</h2>
          <h3 className="liferay-category-more-benefits__inst-desc">
            Para subir de categoria e ganhar ainda mais pontos, basta atingir o valor mínimo de gastos com passagens a
            cada ano. Confira os benefícios:
          </h3>
        </div>
        {!!cards.length && (
          <div className="liferay-category-more-benefits__carousel">
            <div className="liferay-category-more-benefits__carousel__buttons">
              <button type="button" onClick={prev} disabled={checkScrollLimit().prev}>
                <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.70711 1.10735C8.09763 1.49787 8.09763 2.13104 7.70711 2.52156L3.41421 6.81445L7.70711 11.1073C8.09763 11.4979 8.09763 12.131 7.70711 12.5216C7.31658 12.9121 6.68342 12.9121 6.29289 12.5216L0.585786 6.81445L6.29289 1.10735C6.68342 0.716822 7.31658 0.716822 7.70711 1.10735Z"
                  />
                </svg>
              </button>
              <button type="button" onClick={next} disabled={checkScrollLimit().next}>
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.2929 18.5216C9.90237 18.131 9.90237 17.4979 10.2929 17.1073L14.5858 12.8145L10.2929 8.52156C9.90237 8.13104 9.90237 7.49787 10.2929 7.10735C10.6834 6.71682 11.3166 6.71682 11.7071 7.10735L17.4142 12.8145L11.7071 18.5216C11.3166 18.9121 10.6834 18.9121 10.2929 18.5216Z"
                  />
                </svg>
              </button>
            </div>
            <div className="liferay-category-more-benefits__carousel__cards" ref={containerRef}>
              {cards.map(({ type, title, desc1, desc2 }) => (
                <div
                  className={`liferay-category-more-benefits__carousel__inst-card ${type} inst-categorias`}
                  key={v4()}
                >
                  <div className="top">
                    <div className="icon">
                      <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M26.9193 6.14795L5.33268 6.14795C3.86602 6.14795 2.67935 7.34795 2.67935 8.81462L2.67935 14.1479C4.14602 14.1479 5.33268 15.3479 5.33268 16.8146C5.33268 18.2813 4.14602 19.4813 2.66602 19.4813V24.8146C2.66602 26.2813 3.86602 27.4813 5.33268 27.4813H26.666C28.1327 27.4813 29.3327 26.2813 29.3327 24.8146V8.81462C29.3327 7.34795 28.2527 6.14795 26.9193 6.14795ZM23.6393 18.5479L11.826 21.6946L9.61268 17.8546L10.8527 17.5213L12.5327 18.8413L15.7193 17.9879L12.5194 12.4413L14.386 11.9346L19.7327 16.9213L22.986 16.0546C23.666 15.8679 24.3727 16.2813 24.5593 16.9613C24.7327 17.6413 24.3327 18.3479 23.6393 18.5479Z" />
                      </svg>
                    </div>
                    <div className="text">{title}</div>
                  </div>
                  <div className="inst-bottom">
                    <div className="desc">{desc1}</div>
                    <div className="desc">{desc2}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="mobile-dots">
              {cards.map((_card, index) => (
                <span
                  className={`mobile-dots__dot${index + 1 === carouselState.current ? " current" : ""}`}
                  key={v4()}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default InstBenefitsCategorias;
